import axios from 'axios';
import { getToken, clearAuth } from './authStorage';

/**
 * Chuẩn hóa base URL cho axios và link tải file.
 * - Cho phép REACT_APP_API_BASE = http://host:port (tự thêm /api)
 * - Cho phép /api (dùng với "proxy" trong package.json)
 */
function resolvedApiBase() {
  let b = (process.env.REACT_APP_API_BASE || 'http://localhost:3002/api').trim();
  b = b.replace(/\/$/, '');
  if (/^https?:\/\//i.test(b) && !/\/api$/i.test(b)) {
    b = `${b}/api`;
  }
  if (!b.startsWith('http') && !b.startsWith('/')) {
    b = `/${b}`;
  }
  return b;
}

const apiBaseResolved = resolvedApiBase();

const api = axios.create({
  baseURL: apiBaseResolved,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && typeof window !== 'undefined') {
      const p = window.location.pathname || '';
      if (!p.endsWith('/login')) {
        const had = !!getToken();
        clearAuth();
        if (had) window.location.assign('/login');
      }
    }
    return Promise.reject(err);
  }
);

/**
 * URL gốc API (axios defaults), không dấu / cuối
 * @deprecated Dùng apiDownloadUrl cho link file
 */
export function apiBaseUrl() {
  return (api.defaults.baseURL || '').replace(/\/$/, '');
}

/**
 * URL đầy đủ tải file / GET tĩnh trên API (đã gồm tiền tố /api khi cần).
 * @param {string} resourcePath ví dụ 'sample-tasks-template' (không có / đầu)
 */
export function apiDownloadUrl(resourcePath) {
  const path = String(resourcePath || '').replace(/^\//, '');
  const base = (api.defaults.baseURL || '').replace(/\/$/, '');
  return `${base}/${path}`;
}

export default api;
